import { Injectable, inject } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from "@angular/router";
import { AuthService } from "../services";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root'
})
export class EpnGuardService {
  private authService = inject(AuthService);


  async canActivate(_next: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Promise<boolean> {
    const user = await this.authService.getAuthUser();
    const isEpn = user?.isEpn ? true : false;

    if (!isEpn) {
      const errorMessage = 'Unauthorized: User does not have permission to access this page.';
      location.href = environment.manageAccountUrl + 'error?errorMessage=' + errorMessage;
      return false;
    }
    return true;
  }
}

export const EpnGuard: CanActivateFn = async (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> => {
  return await inject(EpnGuardService).canActivate(next, state);
}